import { Entry } from '../Entry'

export function Entry20220127() {
  return (
    <Entry title="27/01/2022 - v3.0.0-beta-14">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12411/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
